import React, { FC } from 'react'
import { StyledOrderItem, OrderItemType } from '.'

type Props = {
  item: OrderItemType;
  discountApplied?: boolean;
}

const OrderItem: FC<Props> = ({ item, discountApplied }) => {
  return (
    <StyledOrderItem discountApplied={discountApplied}>
      <div className="item-details-container">
        {item.imageURL && (
          <div className="item-preview-image">
            <img src={item.imageURL} alt="" />
          </div>
        )}
        <div className="item-details">
          <span className="item-label">{item.label}</span>
          {item.subLabel && <span className="item-sub-label">{item.subLabel}</span>}
        </div>
      </div>
      <b className="item-price">${item.price}</b>
    </StyledOrderItem>
  )
}

export default OrderItem
